(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vivazz-buy-together"] && !Shopify.designMode) return;
  try {
    class VivazzBuyTogether extends HTMLElement {
    connectedCallback() {
      if (this.closest('#quick-add-dialog') || this.dataset.loaded === 'true') return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.vivazz-pair__track');
      this.previous = this.querySelector('[data-pair-prev]');
      this.next = this.querySelector('[data-pair-next]');
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => this.updateArrows(), { signal, passive: true });
      this.resize = new ResizeObserver(() => this.updateArrows());
      this.resize.observe(this.track);
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.load(signal);
      }, { rootMargin: '300px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
    }
    async load(signal) {
      try {
        for (const intent of ['complementary', 'related']) {
          const url = new URL(this.dataset.url, location.origin);
          url.searchParams.set('product_id', this.dataset.productId);
          url.searchParams.set('section_id', 'vivazz-buy-together');
          url.searchParams.set('limit', this.dataset.limit || '4');
          url.searchParams.set('intent', intent);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, { signal });
          if (!response.ok) throw new Error('Recommendations unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const items = Array.from(html.querySelectorAll('[data-pair-item]'));
          if (!items.length) continue;
          this.track.replaceChildren(...items);
          this.dataset.loaded = 'true';
          this.dataset.source = intent;
          this.track.setAttribute('aria-busy', 'false');
          this.querySelector('.vivazz-pair__navigation').hidden = items.length < 2;
          requestAnimationFrame(() => this.updateArrows());
          return;
        }
        this.hidden = true;
      } catch (error) {
        if (error.name !== 'AbortError') this.hidden = true;
      }
    }
    move(direction) {
      const item = this.track.querySelector('[data-pair-item]');
      if (!item) return;
      const step = item.getBoundingClientRect().width + 16;
      this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    updateArrows() {
      if (!this.track) return;
      this.previous.disabled = this.track.scrollLeft < 4;
      this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 4;
    }
  }
  if (!customElements.get('vivazz-buy-together')) customElements.define('vivazz-buy-together', VivazzBuyTogether);
  } catch(e) { console.error(e); }
})();

})();
